<template>
  <div class="flex flex-col h-screen w-full">
    <div
      class="flex justify-between items-center h-14 min-h-[3.5rem] px-4 py-2 bg-white dark:bg-slate-900 border-b border-slate-50 dark:border-slate-800/50"
    >
      <div class="flex w-full payment-style">
        <div class="flex items-center w-[30%]">
          <div class="back-icon" @click="backUrl">
            <fluent-icon
              v-tooltip="'Back'"
              icon="back"
              :viewBox="'0 0 52 52'"
              size="14"
              class="mt-0.5 grey-color"
            />
          </div>
          <div class="pipeline-heading" @click="softReloadPage">
            {{ $t('SIDEBAR.PAYMENT') }}
          </div>
        </div>
        <!-- <div class="flex justify-end w-[70%]">
          <woot-button class="import-clear">
            {{ $t('EXPORT_CONTACTS.NEW_PAYMENT') }}
          </woot-button>
        </div> -->
      </div>
    </div>
    <div class="flex-grow overflow-y-auto">
      <div class="pipeline-container ">
        <payment-dashboard @payments-fetched="handlePayments" />
      </div>
    </div>
      <div v-if="uiFlags.isFetching" class="loadingScreeen">
      <loading-state v-if="uiFlags.isFetching" :message="emptyStateMessage"  font-size="text-[30px]"   font-weight="font-semibold" />
    </div>
  </div>
</template>

  

<script>
import { mapGetters } from 'vuex';
import PaymentDashboard from './components/Payment-dashboard.vue';
import LoadingState from 'dashboard/components/widgets/LoadingState';


export default {
  components: {
    PaymentDashboard,
    LoadingState

  },
  data(){
    return{
      parentPaymentsList:null,
      emptyStateMessage: 'Loading Payments',
    }
  },
  computed: {
    ...mapGetters({
      uiFlags: 'payments/getUIFlags',
    }),
  },
  mounted() {
  document.title = `${this.$t('SIDEBAR.PAYMENT')} | Kivo`;
},

  methods: {
    backUrl() {
      this.$router.push({ name: 'settings_account_reports' });
    },
    softReloadPage() {
      this.$router.go(0);
    },
    handlePayments(data) {
    console.log('Received from child:', data);
    this.parentPaymentsList = data; // or whatever handling you need
  }
  },
};
</script>

<style lang="scss" scoped>
.w-100 {
  width: 100%;
}
.payment-style {
  padding: 0px 10px;
}
.import-clear {
  background-color: #40518a !important;
  font-size: 14px;
  padding: 20px 10px;
}
.pipeline-container {
  overflow-x: auto; /* Enable horizontal scrolling */
  background: #c9c7c729;
  height: 100%;
}
.loadingScreeen{
  position: absolute;
  z-index: 10;
  background-color: #443f3f6e;
  inset: 0;
  display: grid;
  place-items: center;
  font-size: 30px;
  color: white;
}
</style>